import React, { useRef, useState, useEffect } from "react";

//loaders
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

import ReactECharts from "echarts-for-react";
import html2canvas from "html2canvas";
import JSZip from "jszip";

import Button from "@mui/material/Button";
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';

import { MainButton } from "../../SXStyle";
import { excelAFecha } from "../../functions/functions.js";

function ToneladasGraphs(props) {
  const {
    visible,
    dataExcel,
    openLoader,
    setOpenLoader,
    fechaInicio,
    fechaFinal,
    yAxis,
    yInter,
    y2Axis,
    y2Inter,
    text,
    subText,
  } = props;

  const chartRef = useRef(null);

  const [dataGrafica, setDataGrafica] = useState({
    fechas: [],
    ton_plan: [], //eje x
    ton_real: [], //eje y
    plan_acumulado_ton: [], //eje x
    real_acumulado_ton: [], //eje y
  });

  /*filtra los registros por fecha y obtiene solos los registros que se van a ocupar
    para graficas */
  useEffect(() => {
    if (dataExcel.length > 0) {
      fetchExcel(fechaInicio, fechaFinal);
      setOpenLoader(false);
    }
  }, [dataExcel, fechaInicio, fechaFinal]);

  useEffect(() => {
    // Forzar resize cuando los datos cambian o cuando se hace visible
    if (chartRef.current && dataExcel.length > 0) {
      chartRef.current.getEchartsInstance().resize();
    }
  }, [dataExcel, visible]);

  const fetchExcel = async (fechaInicio, fechaFinal) => {
    try {
      let _fechas = [];
      let _ton_plan = []; //eje x
      let _ton_real = []; //eje y
      let _plan_acumulado_ton = []; //eje x
      let _real_acumulado_ton = []; //eje y

      //filtra los registros por fecha y añade una columna nueva (fecha string)
      const _datosExcel = dataExcel
        .filter((row) => row[0] >= fechaInicio && row[0] <= fechaFinal)
        .map((row) => {
          _fechas.push(excelAFecha(row[0]));
          _ton_plan.push(row[3]);
          _ton_real.push(row[16]);
          _plan_acumulado_ton.push(row[2]);
          _real_acumulado_ton.push(row[15]);
        });

      setDataGrafica({
        fechas: _fechas,
        ton_plan: _ton_plan,
        ton_real: _ton_real,
        plan_acumulado_ton: _plan_acumulado_ton,
        real_acumulado_ton: _real_acumulado_ton,
      });
    } catch (err) {
      console.error(err);
    }
  };

  const option = {
    title: {
      text: text,
      subtext: subText,
      left: "center",
      top: 40,
      textStyle: {
        fontSize: 16,
        fontWeight: "bold",
        color: "#7b7b7b",
      },
      subtextStyle: {
        fontSize: 14,
        fontWeight: "bold",
        color: "#9c9c9c",
      },
    },
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "cross",
        crossStyle: {
          color: "#999",
        },
      },
    },
    toolbox: {
      feature: {
        dataView: {
          show: true,
          readOnly: true,
          optionToContent: function (opt) {
            const categorias = opt.xAxis[0].data;

            const seriesMap = {};
            opt.series.forEach((s) => {
              seriesMap[s.name] = s.data;
            });

            // Encabezados personalizados
            const headers = [
              "Fecha",
              "Ton (Plan)", //eje x
              "Ton (Real)", //eje x
              "Plan Acumulado Ton", //eje y
              "Real Acumulado Ton", //eje y
            ];

            let table = `
              <table style="width:100%;border-collapse:collapse;text-align:center;" border="1">
                <thead>
                  <tr>
                    ${headers
                      .map(
                        (h) =>
                          `<th style="padding:4px;background:#f2f2f2">${h}</th>`
                      )
                      .join("")}
                  </tr>
                </thead>
                <tbody>
            `;

            // Recorrer todas las fechas
            for (let i = 0; i < categorias.length; i++) {
              table += "<tr>";
              table += `<td>${categorias[i]}</td>`;
              table += `<td>${format(seriesMap["Ton (Plan)"]?.[i])}</td>`;
              table += `<td>${format(seriesMap["Ton (Real)"]?.[i])}</td>`;
              table += `<td>${format(
                seriesMap["Plan Acumulado Ton"]?.[i]
              )}</td>`;
              table += `<td>${format(
                seriesMap["Real Acumulado Ton"]?.[i]
              )}</td>`;
              table += "</tr>";
            }

            table += "</tbody></table>";
            return table;

            // Función de formato segura
            function format(val) {
              return isNaN(val) || val === null || val === ""
                ? "---"
                : parseFloat(val).toFixed(2);
            }
          },
        },

        //otros tipos de graficas
        magicType: {
          show: true,
          type: ["line", "bar"],
          title: {
            line: "Cambiar a Línea",
            bar: "Cambiar a Barra",
          },
        },
        restore: { show: true },
        saveAsImage: { show: true },
      },
    },
    //leyendas y data
    legend: {
      data: [
        "Ton (Plan)",
        "Ton (Real)",
        "Plan Acumulado Ton",
        "Real Acumulado Ton",
      ],
    },
    xAxis: [
      {
        type: "category",
        data: dataGrafica.fechas,
        axisPointer: {
          type: "shadow",
        },
      },
    ],
    yAxis: [
      {
        type: "value",
        name: "TONELADAS",
        min: 0,
        max: yAxis,
        interval: yInter,
        axisLabel: {
          formatter: "{value}",
        },
      },
      {
        type: "value",
        name: "Acumulado Toneladas",
        min: 0,
        max: y2Axis,
        interval: y2Inter,
        axisLabel: {
          formatter: "{value}",
        },
      },
    ],
    series: [
      {
        name: "Ton (Plan)",
        type: "bar",
        itemStyle: {
          color: "#c9c9c9",
        },
        label: {
          show: true,
          position: "top",
          fontSize: 10,
          color: "#7e7e7e",
          formatter: (val) => {
            return isNaN(val.value) ? "ø" : parseFloat(val.value).toFixed(2);
          },
        },
        tooltip: {
          valueFormatter: function (value) {
            return isNaN(value) || value === null || value === ""
              ? "ø"
              : parseFloat(value).toFixed(2);
          },
        },
        data: dataGrafica.ton_plan,
      },
      {
        name: "Ton (Real)",
        type: "bar",
        itemStyle: {
          color: "#ffdb96",
        },
        label: {
          show: true,
          position: "top",
          fontSize: 10,
          color: "#7e7e7e",
          formatter: (val) => {
            return isNaN(val.value) ? "ø" : parseFloat(val.value).toFixed(2);
          },
        },
        tooltip: {
          valueFormatter: function (value) {
            return isNaN(value) || value === null || value === ""
              ? "ø"
              : parseFloat(value).toFixed(2);
          },
        },
        data: dataGrafica.ton_real,
      },
      {
        name: "Plan Acumulado Ton",
        type: "line",
        yAxisIndex: 1,
        itemStyle: {
          color: "#7f7f7f",
        },
        lineStyle: {
          width: 3,
          type: "solid",
        },
        label: {
          show: true,
          position: "right",
          fontSize: 8,
          color: "#010101",
          backgroundColor: "#bfbfbf", // color de fondo
          borderRadius: 4, // bordes redondeados
          padding: [4, 5], // espacio interno: [vertical, horizontal]
          formatter: (val) => {
            return isNaN(val.value) ? "ø" : parseFloat(val.value).toFixed(2);
          },
        },
        tooltip: {
          valueFormatter: function (value) {
            return isNaN(value) || value === null || value === ""
              ? "ø"
              : parseFloat(value).toFixed(2);
          },
        },
        data: dataGrafica.plan_acumulado_ton,
      },
      {
        name: "Real Acumulado Ton",
        type: "line",
        yAxisIndex: 1,
        itemStyle: {
          color: "#e87a30",
        },
        lineStyle: {
          width: 3,
          type: "solid",
        },
        label: {
          show: true,
          position: "right",
          fontSize: 8,
          color: "#010101",
          backgroundColor: "#ffe598", // color de fondo
          borderRadius: 4, // bordes redondeados
          padding: [4, 5], // espacio interno: [vertical, horizontal]
          formatter: (val) => {
            return isNaN(val.value) ? "ø" : parseFloat(val.value).toFixed(2);
          },
        },
        tooltip: {
          valueFormatter: function (value) {
            return isNaN(value) || value === null || value === ""
              ? "ø"
              : parseFloat(value).toFixed(2);
          },
        },
        data: dataGrafica.real_acumulado_ton,
      },
    ],
  };

  // Manejar evento de restauración
  const onEvents = {
    restore: () => {
      // Reaplica el gráfico original
      chartRef.current.getEchartsInstance().setOption(option, true);
    },
  };

  //guarda la grafica y la tabla en un zip
  const handleSaveImage = async (text) => {
    const zip = new JSZip();

    // 1. Genera la imagen del gráfico
    const echartsInstance = chartRef.current.getEchartsInstance();
    const imageURL = echartsInstance.getDataURL({
      type: "png",
      pixelRatio: 2,
      backgroundColor: "#fff",
    });
    const graficaBlob = await (await fetch(imageURL)).blob();
    zip.file("grafica.png", graficaBlob);

    // 2. Genera la imagen de la tabla
    const tablaBlob = await exportTableToBlob();
    zip.file("grafica_tabla.png", tablaBlob);

    // 3. Genera y descarga el ZIP
    const content = await zip.generateAsync({ type: "blob" });
    const a = document.createElement("a");
    a.href = URL.createObjectURL(content);
    a.download = text + ".zip";
    a.click();
  };

  //convierte la tabla de datos en un blob
  const exportTableToBlob = async () => {
    const element = document.getElementById("tabla-ton-datos");
    const originalWidth = element.style.width;
    const originalOverflow = element.style.overflow;

    element.style.width = element.scrollWidth + "px";
    element.style.overflow = "visible";

    const canvas = await html2canvas(element);

    element.style.width = originalWidth;
    element.style.overflow = originalOverflow;

    return await new Promise((resolve) =>
      canvas.toBlob((blob) => resolve(blob), "image/png")
    );
  };

  return (
    <div className="p-4 rounded-lg shadow-lg  bg-blanco border-gray-600 mt-1 w-full">
      {/* Loader */}
      <Backdrop
        sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
        open={openLoader}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      <div style={{ width: "100%", height: "70vh" }}>
        <ReactECharts
          ref={chartRef}
          option={option}
          onEvents={onEvents}
          style={{ width: "100%", height: "100%" }}
        />
      </div>

      {/* Estadisticas */}
      <div id="tabla-ton-datos" className="overflow-x-auto border rounded-lg">
        <div className="inline-block min-w-full">
          <div
            className="grid"
            style={{
              gridTemplateColumns: `150px repeat(${dataGrafica.plan_acumulado_ton.length}, auto)`,
              gridTemplateRows: "repeat(5, auto)",
            }}
          >
            {/* Fechas */}
            <div className="border border-gray-300 p-2"></div>

            {dataGrafica.fechas.map((col, colIndex) => (
              <div
                key={`cell-${colIndex}`}
                className="border border-gray-300 p-2 text-inputs text-[10px]"
              >
                {col}
              </div>
            ))}

            {/* Ton (Plan) */}
            <div className="border border-gray-300 p-2 font-bold bg-gray-200 text-[10px] flex ">
              <div className="bg-[#c9c9c9] w-[30px] h-[20px] mt-[2px] mr-3"></div>
              <p className="mt-1"> Ton (Plan) </p>
            </div>

            {dataGrafica.ton_plan.map((col, colIndex) => (
              <div
                key={`cell-${colIndex}`}
                className="border border-gray-300 p-2 text-inputs text-[10px]"
              >
                {typeof col === "number" ? col.toFixed(2) : ""}
              </div>
            ))}

            {/* Ton (Real)  */}
            <div className="border border-gray-300 p-2 font-bold bg-gray-200 text-[10px] flex">
              <div className="bg-[#f5b498] w-[30px] h-[20px] mt-[2px] mr-3"></div>
              <p className="mt-1"> Ton (Real) </p>
            </div>

            {dataGrafica.ton_real.map((col, colIndex) => (
              <div
                key={`cell-${colIndex}`}
                className="border border-gray-300 p-2 text-inputs text-[10px]"
              >
                {typeof col === "number" ? col.toFixed(2) : ""}
              </div>
            ))}

            {/* Acumulado PLAN TON */}
            <div className="border border-gray-300 p-2 font-bold bg-gray-200 text-[10px] flex ">
              <div>
                <div className="flex items-center mt-[5px]">
                  <div className="w-2 h-0.5 bg-[#7f7f7f]"></div>
                  <div className="w-3 h-3 rounded-full bg-[#7f7f7f]"></div>
                  <div className="w-2 h-0.5 bg-[#7f7f7f]"></div>
                </div>
              </div>

              <p className="ml-3 mt-[-2px]"> Acumulado PLAN TON </p>
            </div>

            {dataGrafica.plan_acumulado_ton.map((col, colIndex) => (
              <div
                key={`cell-${colIndex}`}
                className="border border-gray-300 p-2 text-inputs text-[10px]"
              >
                {typeof col === "number" ? col.toFixed(2) : ""}
              </div>
            ))}

            {/* Acumulado REAL Oz Au OCM */}
            <div className="border border-gray-300 p-2 font-bold bg-gray-200 text-[10px] flex ">
              <div>
                <div className="flex items-center mt-[5px]">
                  <div className="w-2 h-0.5 bg-[#e87a30]"></div>
                  <div className="w-3 h-3 rounded-full bg-[#e87a30]"></div>
                  <div className="w-2 h-0.5 bg-[#e87a30]"></div>
                </div>
              </div>

              <p className="ml-3 mt-[-2px]"> Acumulado REAL TON </p>
            </div>

            {dataGrafica.real_acumulado_ton.map((col, colIndex) => (
              <div
                key={`cell-${colIndex}`}
                className="border border-gray-300 p-2 text-inputs text-[10px]"
              >
                {typeof col === "number" ? col.toFixed(2) : ""}
              </div>
            ))}
          </div>
        </div>
      </div>

      <Button
        onClick={() => handleSaveImage(text)}
        variant="contained"
        sx={{ ...MainButton, width: "120px" }}
        endIcon={<CloudDownloadIcon />}
      >
        Exportar
      </Button>


    </div>
  );
}

export default ToneladasGraphs;
